<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar>
                        <v-toolbar-title>Reports</v-toolbar-title>
                        
                        <menu-date-picker class="date-container" label="Date From" v-model="dateFrom" @update:model-value="onPeriodUpdate"></menu-date-picker>
                        <menu-time-picker class="time-container" label="Time From" v-model="timeFrom" @update:model-value="onPeriodUpdate"></menu-time-picker>
                        <menu-date-picker class="date-container" label="Date To" v-model="dateTo" @update:model-value="onPeriodUpdate"></menu-date-picker>
                        <menu-time-picker class="time-container" label="Time To" v-model="timeTo" @update:model-value="onPeriodUpdate"></menu-time-picker>
                        <v-btn prepend-icon="mdi-microsoft-excel" variant="elevated" class="mr-3" color="success" @click="exportOn = true" >Export</v-btn>
                        <v-btn prepend-icon="mdi-plus" variant="outlined" class="mr-3" :to="'/reports/create'" >Create</v-btn>
                    </v-toolbar>
                    <v-progress-linear indeterminate :active="loading"></v-progress-linear>
                    <v-container>
                        <v-row class="justify-end">
                            <project-combo-box class="company-container mt-2" label="Project" v-model="project" @update:model-value="loadReset" variant="outlined" :company-id="companyId" strict="false" ></project-combo-box>
                            <company-combo-box class="company-container mt-2" label="Company" v-model="company" @update:model-value="companyChange" variant="outlined" ></company-combo-box>
                            <member-combo-box class="company-container mt-2" label="Member" v-model="member" @update:model-value="loadReset" variant="outlined" v-if="showMember" ></member-combo-box>
                        </v-row>
                    </v-container>
                    <v-table>
                        <colgroup>
                            <col />
                            <col />
                            <col />
                            <col />
                            <col style="width: 150px;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text-left">Number</th>
                                <th class="text-left">Company</th>
                                <th class="text-left">Project</th>
                                <th class="text-left">Operator</th>
                                <th class="text-left">Spent Time</th>
                                <th class="text-left">Shift</th>
                                <th class="text-left">Created</th>
                                <th class="text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in reports" @click="$router.push('/reports/' + item.reportId)" class="click-tr"
                                :key="item.reportId" >
                                <td>{{ item.reportNumber }}</td>
                                <td>{{ item.company?.name }}</td>
                                <td>{{ item.project?.code }}</td>
                                <td>{{ item.member?.name }}</td>
                                <td>{{ item.spentTime }}</td>
                                <td>{{ item.shift }}</td>
                                <td>{{ formatDate(item.createdDate) }}</td>
                                <td>
                                    <v-btn icon="mdi-delete" variant="text" @click="deleteEnity(item.reportId, item.reportNumber)" @click.stop ></v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                    <v-divider></v-divider>
                    <v-toolbar color="surface">
                        <v-toolbar-title></v-toolbar-title>
                        <span density="compact" class="mr-3 free-text">Item per page:</span>
                        <v-select variant="outlined" 
                        density="compact" 
                        hide-details 
                        :items="perPageItems" 
                        v-model="perPage" 
                        style="max-width: 6rem;"
                        @update:modelValue="loadReset" ></v-select>
                        <span density="compact" class="ml-4 mr-4 free-text">{{offset + 1 }} - {{ curentPage() }} of {{ count }}</span>
                        <v-btn icon="mdi-arrow-left" density="compact" variant="text" :disabled="offset == 0" @click="previousPage" ></v-btn>
                        <v-btn icon="mdi-arrow-right" density="compact" variant="text" class="ml-4 mr-12" :disabled="curentPage() >= count" @click="nextPage" ></v-btn>
                    </v-toolbar>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog max-width="500" v-model="dialogOn">
            <v-card title="Delete Report">
                <v-card-text>Are you sure you whant to delete report {{ reportName }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text="Dismist" @click="dialogOn = false"></v-btn>
                    <v-btn text="Delete" color="error" @click="confirmDelete"></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" >{{ message }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
        <report-export-dialog v-model:exportOn="exportOn" :company-id="company?.companyID" :member-id="member?.memberId" :project-id="project?.projectId" :start-date="getStartDate" :end-date="getEndDate"></report-export-dialog>
    </v-container>
</template>

<script>
import ReportApi from '../services/ReportApi'
import moment from 'moment';
import MenuDatePicker from '../components/MenuDatePicker.vue'
import MenuTimePicker from '../components/MenuTimePicker.vue'
import CompanyComboBox from '../components/CompanyComboBox.vue'
import MemberComboBox from '../components/MemberComboBox.vue'
import ProjectComboBox from '../components/ProjectComboBox.vue'
import ReportExportDialog from '../components/ReportExportDialog.vue'
import { useStore } from '../services/store'


export default {
    name: 'ReportPage',
    data() {
        return {
            reports: [],
            perPage: 25,
            search: "",
            orderBy: "reportid-desc",
            offset: 0,
            count: 0,
            perPageItems: [ 10, 15, 25, 50 ],
            reportId: 0,
            reportNumber: "",
            dialogOn: false,
            snackbar: false,
            reportName: '',
            message: '',
            timeout: 2000,
            timeFrom: "00:00",
            timeTo: "00:00",
            dateFrom: "",
            dateTo: "",
            company: null,
            project: null,
            member: null,
            exportOn: false,
            loading: false,
            showMember: false 
        }
    },
    mounted() {
        const store = useStore();
        
        this.showMember = store.role == "Admin"
        var storedPerPage = store.perPage;
        if(storedPerPage && !isNaN(storedPerPage)) 
            this.perPage = parseInt(storedPerPage, 10);
        if(store.reportOrderBy) 
            this.orderBy = store.reportOrderBy
        if(store.reportOffset && !isNaN(store.reportOffset)) 
            this.offset = parseInt(store.reportOffset, 10);
        if(store.reportCount && !isNaN(store.reportCount)) 
            this.count = parseInt(store.reportCount, 10);
        if(store.reportPageCompany && store.reportPageCompany.companyID > 0) 
            this.company = store.reportPageCompany
        if(store.reportPageMember && store.reportPageMember.memberId > 0) 
            this.member = store.reportPageMember
        if(store.reportPageProject && store.reportPageProject.projectId > 0) 
            this.project = store.reportPageProject

        this.setDatePeriodFromStorage()
        this.load()
    },
    components: {
        MenuDatePicker,
        MenuTimePicker,
        CompanyComboBox,
        MemberComboBox,
        ProjectComboBox,
        ReportExportDialog
    },
    computed: {
         companyId() {
            return ( this.company && this.company.companyID > 0 ) ? this.company.companyID : null;
        },
        getStartDate() {
            let localFormat = moment.localeData(navigator.language).longDateFormat('l');
            if(moment(this.dateFrom, localFormat).isValid()) {
                if(this.timeFrom && this.timeFrom.indexOf(":") != -1) 
                    return moment(this.dateFrom, localFormat).format("yyyy-MM-DD") + "T" + this.timeFrom + ":00";
                else 
                    return moment(this.dateFrom, localFormat).format("yyyy-MM-DD") + "T00:00:00";
            }
            else 
                return null;
            
        },
        getEndDate() {
            let localFormat = moment.localeData(navigator.language).longDateFormat('l');
            
            if(moment(this.dateTo, localFormat).isValid()) {
                if(this.timeTo && this.timeTo.indexOf(":") != -1) 
                    return moment(this.dateTo, localFormat).format("yyyy-MM-DD") + "T" + this.timeTo + ":00";
                else 
                    return moment(this.dateTo, localFormat).format("yyyy-MM-DD") + "T00:00:00";
            }
            else 
                return null;
        }
    },
    methods: {
        load() {
            
            let output = this.offset == 0 ? 'count' : ''
            const store = useStore();
            this.loading = true
            ReportApi.search({ 
                offset: this.offset, 
                limit: this.perPage, 
                orderby: this.orderBy,
                startDate: store.reportStartDate ? store.reportStartDate : null,
                endDate: store.reportEndDate ? store.reportEndDate : null,
                search: this.search,
                companyId: this.company && this.company.companyID > 0? this.company.companyID : null,
                memberId: this.member && this.member.memberId > 0 ? this.member.memberId : null,
                projectId: this.project && this.project.projectId > 0 ? this.project.projectId : null,
                output: output,
                orderBy: 'reportid-desc'
            })
            .then((response) => {
                if(response.data && response.data.reports && Array.isArray(response.data.reports)){
                    this.reports = response.data.reports;
                }
                if(response.data && response.data.count) {
                    this.count = response.data.count;
                    store.reportCount = this.count;
                }
            }).finally(() => this.loading = false )
        },
        deleteEnity(id, name) {
            this.reportId = id;
            this.reportNumber = name;
            this.dialogOn = true;
        },
        curentPage() {
            let crtPage = this.offset + this.perPage;
            if(crtPage > this.count)
                return this.count;
            return crtPage;
        },
        loadReset() {
            const store = useStore();
            this.offset = 0;
            store.reportOffset = this.offset;
            store.perPage = this.perPage;
            store.reportPageCompany = this.company && this.company.companyID > 0 && this.company.name ? this.company : null
            store.reportPageMember = this.member && this.member.memberId > 0 && this.member.name ? this.member : null
            store.reportPageProject = this.project && this.project.projectId > 0 && this.project.code ? this.project : null
            
            this.load();
        },
        companyChange(curent, initial) {
            if(curent?.companyID != initial?.companyID) {
                this.project = null;
            }

            this.loadReset();
        },
        nextPage() {
            const store = useStore();
            this.offset += this.perPage;
            store.reportOffset = this.offset;
            this.load()
        },
        previousPage() {
            const store = useStore();
            this.offset -= this.perPage;
            store.reportOffset = this.offset;
            this.load()
        },
        formatDate(dt) {
            return moment(dt).format('DD-MM-YYYY HH:mm')
        },
        confirmDelete() {
            if(!this.reportId)
            {
                this.message = 'Something gone wrong report not found!'
                this.snackbar = true;
            } 
            else {
                ReportApi.delete(this.reportId)
                    .then((response) => {
                            if(response.data && response.data.state){
                                this.message = response.data.state.message
                                this.snackbar = true;
                                this.dialogOn = false;
                                this.load();
                            }
                        })
            }
        },
        onPeriodUpdate() {
            const store = useStore();

            let localFormat = moment.localeData(navigator.language).longDateFormat('l');
            if(moment(this.dateFrom, localFormat).isValid()) {
                if(this.timeFrom && this.timeFrom.indexOf(":") != -1) {
                    store.reportStartDate = moment(this.dateFrom, localFormat).format("yyyy-MM-DD") + " " + this.timeFrom + ":00";
                }
                else {
                    store.reportStartDate = moment(this.dateFrom, localFormat).format("yyyy-MM-DD") + " 00:00:00";
                }
            }
            else {
                store.reportStartDate = '';
            }
            if(moment(this.dateTo, localFormat).isValid()) {
                if(this.timeTo && this.timeTo.indexOf(":") != -1) {
                    store.reportEndDate = moment(this.dateTo, localFormat).format("yyyy-MM-DD") + " " + this.timeTo + ":00";
                }
                else {
                    store.reportEndDate = moment(this.dateTo, localFormat).format("yyyy-MM-DD") + " 00:00:00";
                }
            }
             else {
                store.reportEndDate = '';
            }
            this.loadReset();
        },
        setDatePeriodFromStorage()
        {
            const store = useStore();
            if(moment(store.reportStartDate, 'YYYY-MM-DD HH:mm:ss').isValid()) {
                this.dateFrom = moment(store.reportStartDate, 'YYYY-MM-DD HH:mm:ss').format(moment.localeData(navigator.language).longDateFormat('l'));
                this.timeFrom = moment(store.reportStartDate, 'YYYY-MM-DD HH:mm:ss').format("HH:mm");
            }
            if(moment(store.reportEndDate, 'YYYY-MM-DD HH:mm:ss').isValid()) {
                this.dateTo = moment(store.reportEndDate, 'YYYY-MM-DD HH:mm:ss').format(moment.localeData(navigator.language).longDateFormat('l'));
                this.timeTo = moment(store.reportEndDate, 'YYYY-MM-DD HH:mm:ss').format("HH:mm");
            }
        }
    }
}
</script>


<style>

.date-container {
    width: 7rem;
    margin-right: 1rem;
}

.time-container {
    width: 6rem;
    margin-right: 1rem;
}

.company-container {
    width: 15rem;
    margin-right: 1rem;
}

</style>